





















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Mutation, Getter, Action } from 'vuex-class';
import Card from '@/components/Global/Card.vue';
import verifyPaymentMethod from '@/components/Payment/Methods/VerifyPaymentMethod.vue';

import BillPay from '@/services/BillPay';
import jQuery from 'jquery';
import { PaymentSources } from '@/common/Payments';

@Component({
	name: 'Source',
	components: {
		Card,
		verifyPaymentMethod,
	},
})
export default class Source extends Vue {
	@Prop() private method: PaymentSources;
	@Prop() private admin: boolean;
	@Prop() private userId: string;
	@Prop() private selectedBrand: string;
	private alert: { type: string; title: string; msg: string } = null;
	@Mutation('setPaymentSources', { namespace: 'Payment' }) private setPaymentSources: (
		paymentSource,
	) => void;

	@Mutation('setPaymentSuccess', { namespace: 'Payment' }) private setPaymentSuccess: (
		payload,
	) => void;
	@Action('getRecurringPolicies', { namespace: 'Payment' }) private getRecurringPolicies: any;
	@Getter('recurring_payment', { namespace: 'Payment' }) private recurringPayments: any;
	private loading = false;

	@Watch('alert')
	private watchAlert() {
		this.$emit('update:alert', this.alert);
	}

	private pushId(value) {
		console.log(value);
		this.$emit('selectedId', value);
	}

	get isCard() {
		return this.method.type === 'card';
	}

	get isACH() {
		console.log(this.method.type === 'bank_account');
		return this.method.type === 'bank_account';
	}

	private async removeMethod() {
		// Lets check to see if the method is being used under a recurring payment
		await this.getRecurringPolicies();
		const recurringMethods = this.recurringPayments.flatMap(payment => payment.payment_method);

		if (recurringMethods.includes(this.method.id)) {
			alert(
				"This method cannot be deleted because it's being used for a recurring payment. Please edit or remove the recurring payment and try again.",
			);
			return;
		}

		if (!confirm('Are you sure you want to remove the payment method?')) {
			return;
		}

		try {
			const deleteMethod = await BillPay.deletePaymentMethod({
				id: this.method.id,
			});

			this.setPaymentSources(deleteMethod.data);
			if (this.method.type === 'bank_account' || this.method.type === 'card') {
				this.$emit('update:alert', {
					type: 'success',
					title: 'Payment method removed',
					msg: `Successfuly removed - ${
						this.method.type === 'card' ? 'Card' : 'Bank Account'
					} ending in ${this.method.last4}`,
				});
			}
		} catch (e) {
			console.log(e.response);
		}
	}

	private verifyModal() {
		console.log( 'test' );
		jQuery('#verifyPaymentMethod').modal('show');
	}
}
